export default {
  ImageByStationCode__ALT_TEXT: "Location image",
};
